import { render, staticRenderFns } from "./ProdTartuAdapter.vue?vue&type=template&id=41c47ecc&scoped=true&"
import script from "./ProdTartuAdapter.vue?vue&type=script&lang=js&"
export * from "./ProdTartuAdapter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41c47ecc",
  null
  
)

export default component.exports